import { createAction, props } from '@ngrx/store';
import { Notification } from 'src/app/model/notification';

export const addNotification = createAction(
  'NOTIFICATIONS_ADD_NOTIFICATION',
  props<{
    notification: Notification,
    toastOnly?: boolean,       // If toast only is true, then the notification is not show in list, but only the toast will appear
    listOnly?: boolean         // If list only is true, then the notification is only show in list, toast won't appear
  }>()
);

export const clearToastNotification = createAction(
  'NOTIFICATIONS_CLEAR_TOAST_NOTIFICATION'
);

export const removeNotification = createAction(
  'NOTIFICATIONS_REMOVE_NOTIFICATION',
  props<{ index: number }>()
);

export const clearNotifications = createAction(
  'NOTIFICATIONS_CLEAR_NOTIFICATION'
);

export const setTopbarTitleId = createAction(
  'NOTIFICATIONS_SET_TOPBAR_TITLE',
  props<{ stringId: string }>()
);

export const resetTopbarTitleId = createAction('NOTIFICATIONS_RESET_TOPBAR_TITLE');

export const showProgressSpinner = createAction('NOTIFICATIONS_PROGRESS_SPINNER_SHOW');

export const hideProgressSpinner = createAction('NOTIFICATIONS_PROGRESS_SPINNER_HIDE');